import * as Dialog from "@radix-ui/react-dialog";
import { Button } from "../../Button";
import { Close } from "@/icons";
import "./DoctorConfirmModalHeader.scss";

type DoctorConfirmModalHeaderProps = {
  closeButton?: string;
  onCloseClick?: () => void;
  children?: React.ReactNode;
};

export const DoctorConfirmModalHeader = ({
  closeButton = "Chiudi",
  onCloseClick,
  children,
}: DoctorConfirmModalHeaderProps) => {
  return (
    <header className="ui-doctor-confirm-modal-header bg-white">
      <Dialog.Title className="fs-6 md-fs-custom text-slate-20 fw-bold">
        {children}
      </Dialog.Title>
      <Dialog.Close asChild className="ui-doctor-confirm-modal-header-close">
        <Button
          size="4"
          variant={"closeModal"}
          aria-label="Chiudi modale"
          onClick={onCloseClick}
        >
          {closeButton}
          <Close className="ml-x8" width={32} height={32} />
        </Button>
      </Dialog.Close>
    </header>
  );
};
